import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';
import { Chat } from '@mint-sdk/api-ai-assistant';

import { MarkdownTextAi } from '../../../../components/index.js';

type Props = {
  reasoningMsg: Chat.AiChatMessageRecordType[];
};
const ReasoningTabData = ({ reasoningMsg }: Props) => {
  const actionTypography = typographyVariants({
    variant: 'helperText01',
    color: 'secondary',
  });
  const reasoningTypography = typographyVariants({ variant: 'bodyLong01' });

  return (
    <div className="flex flex-col pl-1" data-testid="reasoning-summary-tab">
      {reasoningMsg.map(({ message, messageId }, i) => {
        const isReasoning =
          message.additionalMetadata.eventType === 'reasoning';

        return (
          <MarkdownTextAi
            key={messageId}
            id="reasoning-summary-msg"
            text={message.content}
            className={cn(
              'mb-1',
              isReasoning && i !== 0 && 'mt-2',
              isReasoning ? reasoningTypography : actionTypography,
            )}
          />
        );
      })}
    </div>
  );
};

export { ReasoningTabData };
